import {createMoreFunSmtDeviceGateBootstrap,type MoreFunSmtDeviceGateEnvironment} from '../../../packages/runtime/smt-runtime-device-gate-provider.ts';
import type {SmtRuntimeAdapterConfig} from './smt-runtime-adapter.ts';

export interface AndroidRuntimeIdentity {
  readonly releaseId:string;
  readonly runtimeVersion:string;
  readonly runtimeChannel:'candidate'|'stable';
}

export interface AndroidRuntimeCandidateIdentity {
  readonly releaseId:string;
  readonly runtimeVersion:string;
}

export function readAndroidRuntimeIdentity(url:URL):AndroidRuntimeIdentity|null{
  if(url.protocol!=='https:'||url.hostname!=='appassets.androidplatform.net'||url.pathname!=='/runtime/index.html')return null;
  const runtimeChannel=url.searchParams.get('runtimeChannel');
  if(runtimeChannel!=='candidate'&&runtimeChannel!=='stable')return null;
  const releaseId=url.searchParams.get('releaseId')?.trim()??'';
  const runtimeVersion=url.searchParams.get('runtimeVersion')?.trim()??'';
  if(!releaseId||!runtimeVersion||releaseId!==runtimeVersion)return null;
  return {releaseId,runtimeVersion,runtimeChannel};
}

export function readAndroidRuntimeCandidateIdentity(url:URL):AndroidRuntimeCandidateIdentity|null{
  const identity=readAndroidRuntimeIdentity(url);
  if(!identity||identity.runtimeChannel!=='candidate')return null;
  return {releaseId:identity.releaseId,runtimeVersion:identity.runtimeVersion};
}

export function createAndroidRuntimeAdapterConfig(
  url:URL,
  environment:MoreFunSmtDeviceGateEnvironment,
):SmtRuntimeAdapterConfig|null{
  if(!readAndroidRuntimeIdentity(url))return null;
  const result=createMoreFunSmtDeviceGateBootstrap(environment);
  if(result.kind!=='ready'||result.profile!=='device-gate')return null;
  return {runtime:result.runtime,...result.adapterInputs};
}

export function createAndroidRuntimeCandidateAdapterConfig(
  url:URL,
  environment:MoreFunSmtDeviceGateEnvironment,
):SmtRuntimeAdapterConfig|null{
  if(!readAndroidRuntimeCandidateIdentity(url))return null;
  return createAndroidRuntimeAdapterConfig(url,environment);
}

export function createDefaultAndroidRuntimeAdapterConfig(url:URL):SmtRuntimeAdapterConfig|null{
  if(!readAndroidRuntimeIdentity(url))return null;
  let sequence=0;
  return createAndroidRuntimeAdapterConfig(url,{
    deviceId:'android-runtime-device-gate',
    now:()=>new Date().toISOString(),
    nextId:(kind)=>`device-gate-${kind}-${++sequence}`,
  });
}

export function createDefaultAndroidRuntimeCandidateAdapterConfig(url:URL):SmtRuntimeAdapterConfig|null{
  if(!readAndroidRuntimeCandidateIdentity(url))return null;
  return createDefaultAndroidRuntimeAdapterConfig(url);
}
